// extracted by mini-css-extract-plugin
export default {"root":"xdhOR","header":"qiuDy","tabs":"TsGBP"};